export default "__VITE_ASSET__006c76e5__"